const NavigationTabs = Object.freeze({
    HOME: 'HOME',
    GENERAL: 'GENERAL',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    EMAILS: 'EMAILS',
    LOGOUT: 'LOGOUT',
});

export default NavigationTabs;
